 angular
 .module('vppApp')
 .directive('validDate', validDate);

 function validDate(){
  return {
    require: 'ngModel',
    link: function(scope, element, attr, mCtrl) {

      function validateDate(value) {

        var date = Date.parse(value);

        if (isNaN(date)) {
          mCtrl.$setValidity('validDate', false);
        }

        var comp = value.split('/');

        if (comp.length !== 3) {
          mCtrl.$setValidity('validDate', false);
        }

        var m = parseInt(comp[0], 10);
        var d = parseInt(comp[1], 10);
        var y = parseInt(comp[2], 10);
        var date = new Date(y, m - 1, d);

        if (date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d){
          mCtrl.$setValidity('validDate', true);
        } else {
          mCtrl.$setValidity('validDate', false);
        }

        return value;
      }
      mCtrl.$parsers.push(validateDate);
    }
  };
};